import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Stats = () => {
  const { t } = useLanguage();

  return (
    <section className="bg-[#0b0817] border-y border-border-dark/60 py-14">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {t.stats.map((stat) => (
            <div
              key={stat.label}
              className="text-center rounded-2xl border border-border-dark bg-card-dark/50 py-8 px-4 hover:border-primary/30 transition-colors"
            >
              <p className="text-4xl lg:text-5xl font-extrabold font-heading text-transparent bg-clip-text bg-gradient-to-r from-primary-light to-pink">
                {stat.value}
              </p>
              <p className="mt-2 text-sm text-slate-400 font-medium">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
